import { useMemo } from "react";
import { FormInput } from "../FormInput";
import { FormSelect } from "../FormSelect";
import { CustomTablePagination } from "./CustomTablePagination";
import { ISelectOption } from "../../common/interfaces";
import { useTranslation } from "react-i18next";

export interface ITableNavbarProps {
  lastPage?: number;
  filtering?: ITableFilterProps;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export interface ITableFilterProps {
  filterLabel: string;
  filterName: string;
  filterOptions: ISelectOption[];
  onFilter: (value: string | number) => void;
}

export const CustomTableNavbar = (props: ITableNavbarProps) => {
  const { t } = useTranslation();

  const { lastPage, filtering, onChange } = props;

  const { filterLabel, filterName, filterOptions, onFilter } = filtering ?? {};

  const allowFiltering = useMemo(
    () => filtering && filterLabel && filterName && filterOptions && onFilter,
    [filtering, filterName, filterLabel, onFilter, filterOptions],
  );

  return (
    <div className="table-navbar d-flex justify-content-between align-items-end gap-2 w-100">
      <FormInput
        name="search"
        className="w-100 w-lg-50"
        onChange={onChange}
        label={t("dashboard.onPageSearchInputLabel")}
        placeholder={t("dashboard.onPageSearchInputPlaceholder")}
      />
      {allowFiltering && (
        <FormSelect
          name={filterName!}
          className="w-100 w-lg-25"
          label={filterLabel!}
          options={[{ value: "", label: "All" }, ...filterOptions!]}
          onChange={onFilter!}
        />
      )}
      {lastPage && <CustomTablePagination last={lastPage ?? 1} className="d-flex justify-content-end w-100" />}
    </div>
  );
};
